import { ModalService } from './shared/services/modal.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { AutenticacaoService } from './services/autenticacao.service';
import { Router } from '@angular/router';
import { Component } from '@angular/core';

import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';
import { VersionCheckService } from './shared/services/version-check-service.service';
// import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  urlVersionFile: string = environment.urlVersionFile;

  constructor(ngbModalConfig: NgbModalConfig,private _versionCheckService: VersionCheckService, private m: ModalService, private idleService: BnNgIdleService, private router: Router, private auth: AutenticacaoService/*, private spinnerService: SpinnerService*/) {
    ngbModalConfig.backdrop = 'static';
    ngbModalConfig.centered = true;
    ngbModalConfig.keyboard = false;

  }

  ngOnInit() {
    // this.m.alert(null, 'Atenção', 'Prezado (a) candidato (a),<br><br>Estamos passando por instabilidades no gmail.<br>Caso não consiga recuperar sua senha, favor substituir seu e-mail. Você pode fazer isso clicando em "Substituir seu e-mail" nesta página.<br><br>Desde já agradecemos a compreensão.<br><br>Gerência de Recursos Humanos');
    this._versionCheckService.initVersionCheck(this.urlVersionFile);
    this.idleTime();
    this.newAccess();
  }

  newAccess() {
    if(localStorage.length > 0) {
      this.auth.logout();
    }
  }

  //Verifica se tempo de inatividade é maior ou igual a 1 hora (em segundos), caso seja redireciona o usuário para tela de login.
  idleTime() {
    this.idleService.startWatching(3600).subscribe((isUserInactive) => {
      if(isUserInactive) {
        const currentRoute = this.router.url;
        if(currentRoute !== '/login') {
          this.auth.logout();
          this.router.navigateByUrl('/login');
          this.idleService.resetTimer();
          this.m.alert(null, 'Atenção', 'Sua sessão expirou, favor realizar autenticação novamente.');
        }
      }
    });
  }

}
